import { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import {
  convertToCurrencyFormat,
  getSerialFromBarcode,
  stockUnitOfMeasureOptions,
  isReadOnlyUser,
} from "../../shared/utility";

export default function CreditReturnCartonsTable(props) {
  const { askDeleteCarton, values, updateCreditReturnItem } = props;
  const isReadOnly = isReadOnlyUser();

  const [items, setItems] = useState(values.items ?? []);

  useEffect(() => {
    setItems(values.items ?? []);
  }, [values.items]);

  function bodyActions(rowData) {
    return (
      <div className="flex">
        {rowData.deleted_at ? (
          <p className="text-black font-bold text-lg">DELETED</p>
        ) : (
          !isReadOnly && (
            <button
              onClick={() => {
                askDeleteCarton(rowData.id);
              }}
              className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
            >
              Delete
            </button>
          )
        )}
      </div>
    );
  }

  const productDetailsBody = (rowData) => {
    return (
      <p>
        <span className="text-gray-900 font-semibold">
          {rowData.product_name}
        </span>
        <br />
        <span className="text-gray-700">PLU:{rowData.plu}</span>
      </p>
    );
  };

  const unitCostBody = (rowData) => {
    const stockUofM = stockUnitOfMeasureOptions.find(
      (opt) => opt.value === rowData.stock_unit_of_measurement,
    )?.label;
    return (
      <p>
        {convertToCurrencyFormat(rowData.unit_cost)}/{stockUofM}
      </p>
    );
  };

  const totalCostBody = (rowData) => {
    var totalCost = 4;

    if (rowData.stock_unit_of_measurement === 1) {
      totalCost =
        parseFloat(rowData.weight_in_kg) * parseFloat(rowData.unit_cost);
    } else if (rowData.stock_unit_of_measurement === 2) {
      totalCost =
        parseFloat(rowData.weight_in_lbs) * parseFloat(rowData.unit_cost);
    } else {
      totalCost =
        parseFloat(rowData.piece_count) * parseFloat(rowData.unit_cost);
    }

    return <p>{convertToCurrencyFormat(totalCost)}</p>;
  };

  const totalShippedWeightParent = (rowData) => {
    return (
      <div>
        <p>{rowData.weight_in_kg}kg</p>
        <p>{rowData.weight_in_lbs}lbs</p>
        <p>{rowData.piece_count} pieces</p>
      </div>
    );
  };

  const unitTypeBody = (value) => {
    switch (value.stock_unit_of_measurement) {
      case 1:
        return "kg";

      case 2:
        return "lbs";

      case 3:
        return "pieces";

      default:
        return "N/A";
    }
  };

  const barcodeBody = (rowData) => {
    return <p>{getSerialFromBarcode(rowData.barcode)}</p>;
  };

  const unitCostEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const onRowEditComplete = (e) => {
    let { newData } = e;

    // Calculate total cost based on stock unit of measurement
    let totalCost = 0;
    if (newData.stock_unit_of_measurement === 1) {
      totalCost =
        parseFloat(newData.weight_in_kg) * parseFloat(newData.unit_cost);
    } else if (newData.stock_unit_of_measurement === 2) {
      totalCost =
        parseFloat(newData.weight_in_lbs) * parseFloat(newData.unit_cost);
    } else {
      totalCost =
        parseFloat(newData.piece_count) * parseFloat(newData.unit_cost);
    }

    // Update local state immediately so the UI reflects the change
    setItems((prev) =>
      prev.map((item) =>
        item.id === newData.id ? { ...newData, total_cost: totalCost } : item,
      ),
    );

    // Make API call to update with both unit cost and total cost
    updateCreditReturnItem(newData.id, {
      unit_cost: newData.unit_cost,
      total_cost: totalCost,
    });
  };

  return (
    <div className="">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden">
            <DataTable
              value={items}
              dataKey="id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 cr-items-table-parent"
              cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
              editMode="row"
              onRowEditComplete={onRowEditComplete}
            >
              <Column header="Product" body={productDetailsBody} />
              <Column header="Barcode" body={barcodeBody} />
              <Column header="Lot Number" field="lot_number" />

              <Column
                header="Amount"
                body={totalShippedWeightParent}
                style={{ textAlign: "right" }}
              />

              <Column
                header="Unit Cost"
                field="unit_cost"
                style={{ textAlign: "right" }}
                body={unitCostBody}
                editor={unitCostEditor}
              />

              <Column
                header="Total Cost"
                field="total_cost"
                style={{ textAlign: "right" }}
                body={totalCostBody}
              />

              <Column
                rowEditor={true}
                headerStyle={{ minWidth: "6rem" }}
                bodyStyle={{ textAlign: "center" }}
              />
              <Column header="" body={bodyActions} />
            </DataTable>
          </div>

          {/* <div className="w-full text-right mt-4">
            <p className="font-bold">
              Subtotal: {convertToCurrencyFormat (values.subtotal_dollar_amount)}
            </p>
            <p className="font-bold">
              Taxes: {convertToCurrencyFormat(values.tax_amount)}
            </p>
            <p className="font-bold">
              Total: {convertToCurrencyFormat(values.total_dollar_amount)}
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
}
